import React from "react"
import { IntlProvider } from "react-intl"

import moment from 'moment'
import "moment/locale/cs"

import messages_en from "../../assets/data/locales/en.json"
import messages_de from "../../assets/data/locales/de.json"
import messages_fr from "../../assets/data/locales/fr.json"
import messages_pt from "../../assets/data/locales/pt.json"
import messages_cs from "../../assets/data/locales/cs.json"

const menu_messages = {
  en: messages_en,
  de: messages_de,
  fr: messages_fr,
  pt: messages_pt,
  cs: messages_cs
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  state = {
    locale: (localStorage.getItem('locale') !== null ? localStorage.getItem('locale') : "cs"),
    messages: menu_messages["cs"]
  }

  componentDidMount () {
    moment.locale('cs');
    if (localStorage.getItem('locale') !== null) localStorage.setItem('locale', 'cs'); 
  }

  render() {
    const { children } = this.props
    const { locale, messages } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: language => {
            moment.locale(language);
            this.setState({
              locale: language,
              messages: menu_messages[language]
            })
          }
        }}
      >
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="cs"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext }
